/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";

// @ts-ignore
import {
  BASE_PATH,
  BaseAPI,
  COLLECTION_FORMATS,
  RequestArgs,
  RequiredError,
  operationServerMap,
} from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  serializeDataIfNeeded,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  toPathString,
} from "../common";
import type { Configuration } from "../configuration";
// @ts-ignore
import { CreateStatsTableRequestDto } from "../models";
// @ts-ignore
import { CreateStatsTableResponseDto } from "../models";
// @ts-ignore
import { GetBackgroundJobResponseDto } from "../models";
// @ts-ignore
import { GetStatServiceGameGroupsRequestDto } from "../models";
// @ts-ignore
import { GetStatServiceGameGroupsResponseDto } from "../models";
// @ts-ignore
import { GetStatServiceGameTypesRequestDto } from "../models";
// @ts-ignore
import { GetStatServiceGameTypesResponseDto } from "../models";
// @ts-ignore
import { GetStatServiceRoomsDataRequestDto } from "../models";
// @ts-ignore
import { GetStatServiceRoomsDataResponseDto } from "../models";
// @ts-ignore
import { GetStatsListResponseDto } from "../models";
// @ts-ignore
import { ListBackgroundJobsResponseDto } from "../models";
// @ts-ignore
import { QueryStatsTableFullResponseDto } from "../models";
// @ts-ignore
import { QueryStatsTableRequestDto } from "../models";
// @ts-ignore
import { QueryStatsTableResponseDto } from "../models";

/**
 * StatsControllerApi - axios parameter creator
 * @export
 */
export const StatsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateStatsTableRequestDto} createStatsTableRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStatsTable: async (
      createStatsTableRequestDto: CreateStatsTableRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createStatsTableRequestDto' is not null or undefined
      assertParamExists(
        "createStatsTable",
        "createStatsTableRequestDto",
        createStatsTableRequestDto
      );
      const localVarPath = `/api/v2/stats/stats-tables`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createStatsTableRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportStatsTableCsv: async (
      userId: number,
      jobId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("exportStatsTableCsv", "userId", userId);
      // verify required parameter 'jobId' is not null or undefined
      assertParamExists("exportStatsTableCsv", "jobId", jobId);
      const localVarPath = `/api/v2/stats/stats-tables/{userId}/{jobId}/export-csv`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackgroundJob: async (
      userId: number,
      jobId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getBackgroundJob", "userId", userId);
      // verify required parameter 'jobId' is not null or undefined
      assertParamExists("getBackgroundJob", "jobId", jobId);
      const localVarPath = `/api/v2/stats/background-jobs/{userId}/{jobId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetStatServiceGameGroupsRequestDto} getStatServiceGameGroupsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGameGroups: async (
      getStatServiceGameGroupsRequestDto: GetStatServiceGameGroupsRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'getStatServiceGameGroupsRequestDto' is not null or undefined
      assertParamExists(
        "getGameGroups",
        "getStatServiceGameGroupsRequestDto",
        getStatServiceGameGroupsRequestDto
      );
      const localVarPath = `/api/v2/stats/game-groups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getStatServiceGameGroupsRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetStatServiceGameTypesRequestDto} getStatServiceGameTypesRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGameTypes: async (
      getStatServiceGameTypesRequestDto: GetStatServiceGameTypesRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'getStatServiceGameTypesRequestDto' is not null or undefined
      assertParamExists(
        "getGameTypes",
        "getStatServiceGameTypesRequestDto",
        getStatServiceGameTypesRequestDto
      );
      const localVarPath = `/api/v2/stats/game-types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getStatServiceGameTypesRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetStatServiceRoomsDataRequestDto} getStatServiceRoomsDataRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoomsData: async (
      getStatServiceRoomsDataRequestDto: GetStatServiceRoomsDataRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'getStatServiceRoomsDataRequestDto' is not null or undefined
      assertParamExists(
        "getRoomsData",
        "getStatServiceRoomsDataRequestDto",
        getStatServiceRoomsDataRequestDto
      );
      const localVarPath = `/api/v2/stats/rooms-data`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getStatServiceRoomsDataRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v2/stats/stats-list`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [userId]
     * @param {string} [jobType]
     * @param {number} [pageNumber]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listBackgroundJobs: async (
      userId?: number,
      jobType?: string,
      pageNumber?: number,
      pageSize?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v2/stats/background-jobs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (userId !== undefined) {
        localVarQueryParameter["userId"] = userId;
      }

      if (jobType !== undefined) {
        localVarQueryParameter["jobType"] = jobType;
      }

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {number} pageNumber
     * @param {number} pageSize
     * @param {QueryStatsTableRequestDto} queryStatsTableRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queryStatsTable: async (
      userId: number,
      jobId: string,
      pageNumber: number,
      pageSize: number,
      queryStatsTableRequestDto: QueryStatsTableRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("queryStatsTable", "userId", userId);
      // verify required parameter 'jobId' is not null or undefined
      assertParamExists("queryStatsTable", "jobId", jobId);
      // verify required parameter 'pageNumber' is not null or undefined
      assertParamExists("queryStatsTable", "pageNumber", pageNumber);
      // verify required parameter 'pageSize' is not null or undefined
      assertParamExists("queryStatsTable", "pageSize", pageSize);
      // verify required parameter 'queryStatsTableRequestDto' is not null or undefined
      assertParamExists(
        "queryStatsTable",
        "queryStatsTableRequestDto",
        queryStatsTableRequestDto
      );
      const localVarPath = `/api/v2/stats/stats-tables/{userId}/{jobId}/stats`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        queryStatsTableRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {string} xStatId
     * @param {string} yStatId
     * @param {string} zStatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queryStatsTableFull: async (
      userId: number,
      jobId: string,
      xStatId: string,
      yStatId: string,
      zStatId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("queryStatsTableFull", "userId", userId);
      // verify required parameter 'jobId' is not null or undefined
      assertParamExists("queryStatsTableFull", "jobId", jobId);
      // verify required parameter 'xStatId' is not null or undefined
      assertParamExists("queryStatsTableFull", "xStatId", xStatId);
      // verify required parameter 'yStatId' is not null or undefined
      assertParamExists("queryStatsTableFull", "yStatId", yStatId);
      // verify required parameter 'zStatId' is not null or undefined
      assertParamExists("queryStatsTableFull", "zStatId", zStatId);
      const localVarPath = `/api/v2/stats/stats-tables/{userId}/{jobId}/stats-full`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xStatId !== undefined) {
        localVarQueryParameter["xStatId"] = xStatId;
      }

      if (yStatId !== undefined) {
        localVarQueryParameter["yStatId"] = yStatId;
      }

      if (zStatId !== undefined) {
        localVarQueryParameter["zStatId"] = zStatId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshStatsTable: async (
      userId: number,
      jobId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("refreshStatsTable", "userId", userId);
      // verify required parameter 'jobId' is not null or undefined
      assertParamExists("refreshStatsTable", "jobId", jobId);
      const localVarPath = `/api/v2/stats/stats-tables/{userId}/{jobId}/refresh`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * StatsControllerApi - functional programming interface
 * @export
 */
export const StatsControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = StatsControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateStatsTableRequestDto} createStatsTableRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createStatsTable(
      createStatsTableRequestDto: CreateStatsTableRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateStatsTableResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createStatsTable(
        createStatsTableRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.createStatsTable"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportStatsTableCsv(
      userId: number,
      jobId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportStatsTableCsv(
        userId,
        jobId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.exportStatsTableCsv"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBackgroundJob(
      userId: number,
      jobId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBackgroundJobResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBackgroundJob(
        userId,
        jobId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.getBackgroundJob"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {GetStatServiceGameGroupsRequestDto} getStatServiceGameGroupsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGameGroups(
      getStatServiceGameGroupsRequestDto: GetStatServiceGameGroupsRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetStatServiceGameGroupsResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getGameGroups(
        getStatServiceGameGroupsRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.getGameGroups"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {GetStatServiceGameTypesRequestDto} getStatServiceGameTypesRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGameTypes(
      getStatServiceGameTypesRequestDto: GetStatServiceGameTypesRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetStatServiceGameTypesResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getGameTypes(
        getStatServiceGameTypesRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.getGameTypes"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {GetStatServiceRoomsDataRequestDto} getStatServiceRoomsDataRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoomsData(
      getStatServiceRoomsDataRequestDto: GetStatServiceRoomsDataRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetStatServiceRoomsDataResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomsData(
        getStatServiceRoomsDataRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.getRoomsData"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStatsList(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatsListResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getStatsList(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.getStatsList"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [userId]
     * @param {string} [jobType]
     * @param {number} [pageNumber]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listBackgroundJobs(
      userId?: number,
      jobType?: string,
      pageNumber?: number,
      pageSize?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListBackgroundJobsResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listBackgroundJobs(
        userId,
        jobType,
        pageNumber,
        pageSize,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.listBackgroundJobs"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {number} pageNumber
     * @param {number} pageSize
     * @param {QueryStatsTableRequestDto} queryStatsTableRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async queryStatsTable(
      userId: number,
      jobId: string,
      pageNumber: number,
      pageSize: number,
      queryStatsTableRequestDto: QueryStatsTableRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryStatsTableResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.queryStatsTable(
        userId,
        jobId,
        pageNumber,
        pageSize,
        queryStatsTableRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.queryStatsTable"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {string} xStatId
     * @param {string} yStatId
     * @param {string} zStatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async queryStatsTableFull(
      userId: number,
      jobId: string,
      xStatId: string,
      yStatId: string,
      zStatId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<QueryStatsTableFullResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.queryStatsTableFull(
        userId,
        jobId,
        xStatId,
        yStatId,
        zStatId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.queryStatsTableFull"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refreshStatsTable(
      userId: number,
      jobId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.refreshStatsTable(
        userId,
        jobId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.refreshStatsTable"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * StatsControllerApi - factory interface
 * @export
 */
export const StatsControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = StatsControllerApiFp(configuration);
  return {
    /**
     *
     * @param {CreateStatsTableRequestDto} createStatsTableRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStatsTable(
      createStatsTableRequestDto: CreateStatsTableRequestDto,
      options?: any
    ): AxiosPromise<CreateStatsTableResponseDto> {
      return localVarFp
        .createStatsTable(createStatsTableRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportStatsTableCsv(userId: number, jobId: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .exportStatsTableCsv(userId, jobId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackgroundJob(
      userId: number,
      jobId: string,
      options?: any
    ): AxiosPromise<GetBackgroundJobResponseDto> {
      return localVarFp
        .getBackgroundJob(userId, jobId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GetStatServiceGameGroupsRequestDto} getStatServiceGameGroupsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGameGroups(
      getStatServiceGameGroupsRequestDto: GetStatServiceGameGroupsRequestDto,
      options?: any
    ): AxiosPromise<GetStatServiceGameGroupsResponseDto> {
      return localVarFp
        .getGameGroups(getStatServiceGameGroupsRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GetStatServiceGameTypesRequestDto} getStatServiceGameTypesRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGameTypes(
      getStatServiceGameTypesRequestDto: GetStatServiceGameTypesRequestDto,
      options?: any
    ): AxiosPromise<GetStatServiceGameTypesResponseDto> {
      return localVarFp
        .getGameTypes(getStatServiceGameTypesRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GetStatServiceRoomsDataRequestDto} getStatServiceRoomsDataRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoomsData(
      getStatServiceRoomsDataRequestDto: GetStatServiceRoomsDataRequestDto,
      options?: any
    ): AxiosPromise<GetStatServiceRoomsDataResponseDto> {
      return localVarFp
        .getRoomsData(getStatServiceRoomsDataRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatsList(options?: any): AxiosPromise<GetStatsListResponseDto> {
      return localVarFp.getStatsList(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [userId]
     * @param {string} [jobType]
     * @param {number} [pageNumber]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listBackgroundJobs(
      userId?: number,
      jobType?: string,
      pageNumber?: number,
      pageSize?: number,
      options?: any
    ): AxiosPromise<ListBackgroundJobsResponseDto> {
      return localVarFp
        .listBackgroundJobs(userId, jobType, pageNumber, pageSize, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {number} pageNumber
     * @param {number} pageSize
     * @param {QueryStatsTableRequestDto} queryStatsTableRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queryStatsTable(
      userId: number,
      jobId: string,
      pageNumber: number,
      pageSize: number,
      queryStatsTableRequestDto: QueryStatsTableRequestDto,
      options?: any
    ): AxiosPromise<QueryStatsTableResponseDto> {
      return localVarFp
        .queryStatsTable(
          userId,
          jobId,
          pageNumber,
          pageSize,
          queryStatsTableRequestDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {string} xStatId
     * @param {string} yStatId
     * @param {string} zStatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queryStatsTableFull(
      userId: number,
      jobId: string,
      xStatId: string,
      yStatId: string,
      zStatId: string,
      options?: any
    ): AxiosPromise<QueryStatsTableFullResponseDto> {
      return localVarFp
        .queryStatsTableFull(userId, jobId, xStatId, yStatId, zStatId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {string} jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshStatsTable(userId: number, jobId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .refreshStatsTable(userId, jobId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * StatsControllerApi - object-oriented interface
 * @export
 * @class StatsControllerApi
 * @extends {BaseAPI}
 */
export class StatsControllerApi extends BaseAPI {
  /**
   *
   * @param {CreateStatsTableRequestDto} createStatsTableRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public createStatsTable(
    createStatsTableRequestDto: CreateStatsTableRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .createStatsTable(createStatsTableRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {string} jobId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public exportStatsTableCsv(userId: number, jobId: string, options?: RawAxiosRequestConfig) {
    return StatsControllerApiFp(this.configuration)
      .exportStatsTableCsv(userId, jobId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {string} jobId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public getBackgroundJob(userId: number, jobId: string, options?: RawAxiosRequestConfig) {
    return StatsControllerApiFp(this.configuration)
      .getBackgroundJob(userId, jobId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GetStatServiceGameGroupsRequestDto} getStatServiceGameGroupsRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public getGameGroups(
    getStatServiceGameGroupsRequestDto: GetStatServiceGameGroupsRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .getGameGroups(getStatServiceGameGroupsRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GetStatServiceGameTypesRequestDto} getStatServiceGameTypesRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public getGameTypes(
    getStatServiceGameTypesRequestDto: GetStatServiceGameTypesRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .getGameTypes(getStatServiceGameTypesRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GetStatServiceRoomsDataRequestDto} getStatServiceRoomsDataRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public getRoomsData(
    getStatServiceRoomsDataRequestDto: GetStatServiceRoomsDataRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .getRoomsData(getStatServiceRoomsDataRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public getStatsList(options?: RawAxiosRequestConfig) {
    return StatsControllerApiFp(this.configuration)
      .getStatsList(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [userId]
   * @param {string} [jobType]
   * @param {number} [pageNumber]
   * @param {number} [pageSize]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public listBackgroundJobs(
    userId?: number,
    jobType?: string,
    pageNumber?: number,
    pageSize?: number,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .listBackgroundJobs(userId, jobType, pageNumber, pageSize, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {string} jobId
   * @param {number} pageNumber
   * @param {number} pageSize
   * @param {QueryStatsTableRequestDto} queryStatsTableRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public queryStatsTable(
    userId: number,
    jobId: string,
    pageNumber: number,
    pageSize: number,
    queryStatsTableRequestDto: QueryStatsTableRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .queryStatsTable(userId, jobId, pageNumber, pageSize, queryStatsTableRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {string} jobId
   * @param {string} xStatId
   * @param {string} yStatId
   * @param {string} zStatId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public queryStatsTableFull(
    userId: number,
    jobId: string,
    xStatId: string,
    yStatId: string,
    zStatId: string,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .queryStatsTableFull(userId, jobId, xStatId, yStatId, zStatId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {string} jobId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public refreshStatsTable(userId: number, jobId: string, options?: RawAxiosRequestConfig) {
    return StatsControllerApiFp(this.configuration)
      .refreshStatsTable(userId, jobId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
